<!-- Requirement: Right-click context menu for dynamic report rows -->
<p-contextMenu #cm [model]="contextMenuItems" appendTo="body"></p-contextMenu>

<!-- Toolbar: search + new report button -->
<div class="p-px-3 p-pt-3 p-pb-2 p-d-flex p-ai-center" style="gap: 0.5rem">
  <!-- Requirement: Search fills all available space; button follows as sibling. -->
  <span class="p-input-icon-right" style="flex-grow: 1">
      <i class="pi pi-spin pi-spinner"
        *ngIf="dynamicReportsQH.loading"
        ></i>
      <button
        type="button"
        class="p-button p-button-text p-button-rounded clear-search"
        *ngIf="!dynamicReportsQH.loading && dynamicReportsQH.search"
        pTooltip="Clear Search"
        aria-label="Clear Search"
        (click)="clearSearch()"
        >
        <i class="pi pi-times" aria-hidden="true"></i>
      </button>
      <input
        type="text"
        #searchInput
        pInputText
        [(ngModel)]="dynamicReportsQH.search"
        (ngModelChange)="filterUpdated.next()"
        placeholder="Search..."
        style="width: 100%"
        >
  </span>
  <!-- Requirement: Renamed from "Build New Report" → "New Report"; passes current
       folder path as a query param so the create dialog pre-fills the path field. -->
  <button
    pButton
    label="New Report"
    routerLink="/reports/dynamic/new"
    [queryParams]="{ path: currentPath === '/' ? null : currentPath }"
    ></button>
</div>

<!-- Requirement: Feature 2 — Folder cards (subfolders of the current path).
     At root, also show a virtual /Static folder that surfaces the legacy static reports.
     Wrapped in a card container so the directory section has a visible background. -->
<div
  *ngIf="folders.length > 0 || showStaticFolder"
  class="p-px-3 p-pb-2"
  >
  <div
    style="
      background: var(--surface-card);
      border: 1px solid var(--surface-border);
      border-radius: 8px;
      padding: 1rem;
      display: flex;
      flex-wrap: wrap;
      gap: 0.75rem;
    "
    >
    <!-- Virtual Static folder — always shown at root, contains no DynamicReport nodes -->
    <button
      type="button"
      *ngIf="showStaticFolder"
      class="p-d-flex p-ai-center"
      style="
        cursor: pointer;
        border: 1px solid var(--surface-border);
        border-radius: 8px;
        padding: 0.75rem 1.25rem;
        gap: 0.6rem;
        background: var(--surface-ground);
        transition: background 0.15s;
      "
      (click)="navigateToFolder('/Static')"
      >
      <i class="pi pi-folder" style="color: var(--yellow-500); font-size: 1.5rem" aria-hidden="true"></i>
      <span style="font-size: 1rem; font-weight: 500">Static</span>
    </button>
    <!-- Dynamic backend-driven folders -->
    <button
      type="button"
      *ngFor="let folder of folders"
      class="p-d-flex p-ai-center"
      style="
        cursor: pointer;
        border: 1px solid var(--surface-border);
        border-radius: 8px;
        padding: 0.75rem 1.25rem;
        gap: 0.6rem;
        background: var(--surface-ground);
        transition: background 0.15s;
      "
      (click)="navigateToFolder(folder.path)"
      >
      <i class="pi pi-folder" style="color: var(--yellow-500); font-size: 1.5rem" aria-hidden="true"></i>
      <span style="font-size: 1rem; font-weight: 500">{{ folder.name }}</span>
      <span class="p-text-secondary" style="font-size: 0.85rem">({{ folder.count }})</span>
    </button>
  </div>
</div>

<!-- Standard paginated report table (text search + folder browsing).
     Hidden when browsing /Static since that path shows only the legacy static table. -->
<p-table
  *ngIf="currentPath !== '/Static'"
  [value]="dynamicReports"
  [paginator]="true"
  (onLazyLoad)="retrieveMoreReports($event)"
  [lazy]="true"
  [totalRecords]="dynamicReportsQH.total"
  [(rows)]="dynamicReportsQH.limit"
  [loading]="dynamicReportsQH.loading"
  [showCurrentPageReport]="!dynamicReportsQH.loading"
  breakpoint="620px"
  >
  <ng-template pTemplate="header">
    <tr>
      <th>Name</th>
      <th>Description</th>
    </tr>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-report
    >
    <!-- Requirement: Right-click context menu on each report row -->
    <tr
      class="selectable-row"
      [routerLink]="['/reports', 'dynamic', report.id ]"
      (contextmenu)="onRightClick($event, report)"
      >
      <td>
        {{ report.name }}
        <span *ngIf="report.descriptionSource === 'ai'" class="p-text-secondary" style="font-size: 0.75rem; margin-left: 4px" pTooltip="Description was auto-generated by AI">
          <i class="pi pi-sparkles"></i>
        </span>
      </td>
      <td>{{ report.description }}</td>
    </tr>
  </ng-template>
</p-table>
